<template>
    <landlords-find
        :params="{
            landlord: $route.params.landlord
        }"
        :include="[
            'bank_account'
        ]"
        @success="onLandlordsFind"
    >
        <div
            slot-scope="{
                data: landlord,
                error: find_error,
                has_loaded,
                find
            }"
        >
            <template v-if="!has_loaded || find_error">
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </template>

            <bank-accounts-store
                v-else
                @success="onBankAccountsStore"
            >
                <base-form
                    slot-scope="{
                        sid,
                        error,
                        is_loading: is_saving,
                        store
                    }"
                    @submit="is_new_bank_account ? store(form) : onBankAccountsStore({ data: landlord.bank_account })"
                >
                    <div class="px-4 pt-6 border-b sm:px-6">
                        <validator-alert :sid="sid" />

                        <form-section>
                            <template slot="title">Bank Account</template>
                            <template slot="description">
                                Where would you like us to deposit your funds?
                            </template>

                            <grid-layout v-if="is_new_bank_account">
                                <grid-layout-item class="md:w-1/2">
                                    <form-item
                                        :sid="sid"
                                        :is-required="true"
                                        name="account_number"
                                    >
                                        <template slot="label">Account Number</template>

                                        <input-text
                                            v-model="form.account_number"
                                            v-mask="['#### ####']"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            type="tel"
                                            name="account_number"
                                            placeholder="0000 0000"
                                        />
                                    </form-item>
                                </grid-layout-item>
                                <grid-layout-item class="md:w-1/2">
                                    <form-item
                                        :sid="sid"
                                        :is-required="true"
                                        name="routing_number"
                                    >
                                        <template slot="label">Sort Code</template>

                                        <input-text
                                            v-model="form.routing_number"
                                            v-mask="['##-##-##']"
                                            :sid="sid"
                                            :disabled="is_saving"
                                            type="tel"
                                            name="routing_number"
                                            placeholder="00-00-00"
                                        />
                                    </form-item>
                                </grid-layout-item>
                            </grid-layout>

                            <div
                                v-else
                                class="flex items-center px-3 py-2 mb-6 border rounded bg-grey-lightest"
                            >
                                <div class="flex-grow overflow-hidden truncate">
                                    **** {{ landlord.bank_account.last_four }}
                                </div>
                                <button
                                    type="button"
                                    class="ml-3 border btn btn-sm"
                                    @click.prevent="is_new_bank_account = true"
                                >
                                    Update
                                </button>
                            </div>
                        </form-section>
                    </div>

                    <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                        <base-button
                            :is-loading="is_saving"
                            class="w-full btn-blue md:w-auto"
                        >
                            Update Account &amp; Continue
                        </base-button>
                    </div>

                    <error-modal
                        v-if="error && $error.is(error, { exclude: [400, 422] })"
                        :error="error"
                    />
                </base-form>
            </bank-accounts-store>
        </div>
    </landlords-find>
</template>

<script>
    import _ from 'lodash'
    import { mask } from 'vue-the-mask'
    import BankAccountsStore from '../../../../../components/bank-accounts-store'
    import LandlordsFind from '../../../../../components/landlords-find'

    export default {
        directives: {
            mask
        },
        components: {
            BankAccountsStore,
            LandlordsFind
        },
        data () {
            return {
                is_new_bank_account: true,
                form: {
                    country: 'gb',
                    currency: 'gbp',
                    account_number: '',
                    routing_number: '',
                    is_default: true
                }
            }
        },
        methods: {
            onLandlordsFind ({ data: { bank_account } }) {
                this.is_new_bank_account = !_.has(bank_account, 'uuid')
            },
            onBankAccountsStore ({ data: bank }) {
                this.$track(
                    'dashboard.landlords.verification.bank.edit',
                    'form-submission',
                    'A landlord has completed step 3 (bank) of verifying their account'
                )

                setTimeout(() => {
                    this.$router.push({
                        name: this.$router.fix('dashboard.*.verification.confirm.edit')
                    })
                }, 0)
            }
        }
    }
</script>
